module.exports = __webpack_public_path__ + "src/assets/textures/molar/table_w_banka_lambert13_AO.jpg";